export function setCookie(name, value) {
    const date = new Date(new Date().getTime() + 2592000000);
    const domain = document.location.hostname;

    document.cookie = name + "=" + value + "; path=/; domain=" + domain + "; expires=" + date.toUTCString() + "; secure; SameSite=Strict";
}

export function getCookie(name) {
    const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

export function setStorageItem(key, value) {
    try {
        return window.localStorage.setItem(key, value)
    } catch (e) {
        console.log(e)
    }
}

export function getStorageItem(key, value) {
    try {
        return window.localStorage.getItem(key)
    } catch (e) {
        console.log(e)
    }
}

export function scrollToBottom() {
    window.scrollTo({top: document.body.scrollHeight, behavior: 'smooth'})
}

export function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

export function returnDay(term) {
    let date = new Date();
    date.setDate(date.getDate() + parseInt(term, 10));
    let dd = date.getDate();
    if (dd < 10) dd = '0' + dd;
    let mm = date.getMonth() + 1;
    if (mm < 10) mm = '0' + mm;
    let yy = date.getFullYear();
    return dd + '.' + mm + '.' + yy;
}

export function slideToggle(e, time = 300) {
    if (getComputedStyle(e).display == 'none') {
        slideShow(e, time);
    } else {
        slideHide(e, time);
    }
}

export function slideShow(e, time = 300) {
    e.style.overflow = 'hidden';

    if (getComputedStyle(e).display == 'none') {
        e.style.display = 'block';

        const h = +getComputedStyle(e).height.replace('px', "");

        setCss(e, '0px', '0px', '0px', '0px', '0px', '0px', '0px');

        setTimeout(() => {
            e.style.transition = time + 'ms';
            setCss(e, h + 'px');
        }, 0);

        setTimeout(() => {
            e.style.display = 'block';
            setCss(e);
            e.style.overflow = '';
            e.style.transition = '';
        }, time);
    }
}

export function slideHide(e, time = 300) {
    e.style.overflow = 'hidden';

    if (getComputedStyle(e).display != 'none') {
        const h = +getComputedStyle(e).height.replace('px', "");

        e.style.height = h + 'px';

        setTimeout(() => {
            e.style.transition = time + 'ms';
            setCss(e, '0px', '0px', '0px', '0px', '0px', '0px', '0px');
        }, 0);


        setTimeout(() => {
            e.style.display = 'none';
            setCss(e);
            e.style.overflow = '';
            e.style.transition = '';
        }, time);
    }
}

function setCss(e, h = '', pT = '', pB = '', mT = '', mB = '', bT = '', bB = '') {
    e.style.height = h;
    e.style.paddingTop = pT;
    e.style.paddingBottom = pB;
    e.style.marginTop = mT;
    e.style.marginBottom = mB;
    e.style.borderTopWidth = bT;
    e.style.borderBottomWidth = bB;
}
